import { render, staticRenderFns } from "./FlagUserModal.vue?vue&type=template&id=46fb4eda&scoped=true"
import script from "./FlagUserModal.vue?vue&type=script&lang=js"
export * from "./FlagUserModal.vue?vue&type=script&lang=js"
import style0 from "./FlagUserModal.vue?vue&type=style&index=0&id=46fb4eda&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46fb4eda",
  null
  
)

export default component.exports